<template>
 <footer class="footer">
          <div class="container-fluid">
            <div class="row">
              <div class="col-md-6 footer-copyright">
                <p class="mb-0">Copyright 2026 © </p>
              </div>
              <div class="col-md-6">
                <p class="pull-right mb-0"> <i class="fa fa-heart font-secondary"></i></p>
              </div>
            </div>
            
          </div>
        </footer>
</template>

<script>
  import json from '../data/menu';
 
  export default {
    components:{
        
    },
    data() {
      return {
        customizer: false,
        data:
          'data:text/json;charset=utf-8,' +
          encodeURIComponent(JSON.stringify(json)),
      };
    },
  };
</script>
